module.exports = __webpack_public_path__ + "2fa685235e15064c91d930605ba8ac92.pdf";